import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import trainer from '../../../image/trainer.png';
import './Banner.css';
const Banner = () => {
    return (
        <div className='banner pt-5 text-white'>
            <Container>
                <Row className='align-items-center'>
                    <Col>
                        <div className="trainer">
                            <img src={trainer} alt="" />
                        </div>
                    </Col>
                    <Col>
                        <div className="trainer-info my-5">
                            <h1 className='fw-bold'>Hi , I am Micheal</h1>
                            <h3 className='my-2 fw-bold'>FITNESS TRAINER</h3>
                            <h4>LET'S SET & REACH YOUR FITNESS GOALS</h4>
                            <p className=' my-3'>Today I will do what others won't, so tomorrow I can accomplish what others can't. We are what we repeatedly do. Excellence then is not an act but a habit. My passion and desire to explore the capabilities of the human body continue to evolve as I learn more and more.
							</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Banner;